import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-login-attempts',
    templateUrl: './login-attempts.component.html',
    styleUrls: ['./login-attempts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LoginAttemptsComponent {}
